import React from "react";
import { Container, Table } from "react-bootstrap";

const AreaBiodiversity = () => {
  return (
    <div className="content-container">
      <h1>Area Biodiversity</h1>
      
	  <Container className="my-5 p-4 border rounded" style={{ backgroundColor: "#fff" }}>
      <h5
        className="fw-semibold mb-3 pb-2"
        style={{ borderBottom: "1px solid #aaa" }}
      >
        Gambaran Umum Area Studi
      </h5>

      <p className="text-start">
        Secara administratif, lokasi kajian meliputi dua wilayah yaitu{" "}
        <strong>Desa Bedegung Kecamatan Tanjung Agung</strong> sebagai lokasi
        pengembangan konservasi <em>biodiversity</em>, dan{" "}
        <strong>Desa Pagardewa Kecamatan Lubai Ulu</strong>, yang merupakan lokasi
        di mana Stasiun Kompresor PGN beroperasi, yang keduanya ada di{" "}
        <strong>Kabupaten Muara Enim Provinsi Sumatera Selatan</strong>.
      </p>

      <p className="text-start">
        Lokasi akan dikembangkannya kawasan{" "}
        <strong>Konservasi Taman Keanekaragaman Hayati</strong> adalah di kawasan
        wisata <strong>Air Terjun Bedegung</strong> yang secara administratif masuk
        ke dalam wilayah Dusun I Desa Bedegung Kecamatan Tanjung Agung. Wilayah
        Desa Bedegung luasnya sekitar <strong>35 Km²</strong>. Adapun letak Desa
        Bedegung memiliki batas wilayah sebagai berikut:
      </p>

      <Table borderless size="sm" className="w-75 mx-auto mb-4">
        <tbody>
          <tr>
            <td className="text-start" style={{ width: "30%" }}>
              Sebelah Utara
            </td>
            <td className="text-start">: Desa Tanjung Agung dan Padang Bindung</td>
          </tr>
          <tr>
            <td className="text-start">Sebelah Selatan</td>
            <td className="text-start">: Kabupaten OKI</td>
          </tr>
          <tr>
            <td className="text-start">Sebelah Timur</td>
            <td className="text-start">: Desa Indramayu</td>
          </tr>
          <tr>
            <td className="text-start">Sebelah Barat</td>
            <td className="text-start">: Desa Tanjung Agung</td>
          </tr>
        </tbody>
      </Table>

      <p className="text-start">
        Adapun letak dan peta desa Bedegung disajikan pada Gambar berikut ini:
      </p>

      <div className="text-center">
        <img
          src="gbrareabiodaversity/gam6.jpg"
          alt="Peta Desa Bedegung"
          className="img-fluid border"
          style={{ maxWidth: "80%", height: "auto" }}
        />
        <div className="fst-italic text-muted mt-2">
          Peta Lokasi Kawasan Wisata Air Terjun Bedegung
        </div>
		
      </div>
	  
	  <div style={{ marginBottom: "10px" }}></div>
	  
	  <p className="text-start">
        Secara administrasi, Stasiun Kompresor PGN Pagardewa terletak di Dusun IV Desa Pagardewa Kecamatan Lubai Ulu. Desa Pagardewa memiliki luas wilayah 119,70 Km2. Desa Pagardewa terdiri dari 6 dusun. Khusus di Dusun IV jumlah RT sebanyak 5 RT dan 2 RW.
      </p>

      <p className="text-start">
        Adapun letak Desa Pagardewa khususnya Dusun IV memiliki batas wilayah sebagai berikut:
      </p>

      <Table borderless size="sm" className="w-75 mx-auto mb-4">
        <tbody>
          <tr>
            <td className="text-start" style={{ width: "30%" }}>
              Sebelah Utara
            </td>
            <td className="text-start">: Berbatasan dengan Desa Sumbermulya</td>
          </tr>
          <tr>
            <td className="text-start">Sebelah Selatan</td>
            <td className="text-start">: Dusun III, berbatasan dengan wilayah Kabupaten OKU</td>
          </tr>
          <tr>
            <td className="text-start">Sebelah Timur</td>
            <td className="text-start">: Berbatasan dengan Desa Karang Agung</td>
          </tr>
          <tr>
            <td className="text-start">Sebelah Barat</td>
            <td className="text-start">: Berbatasan dengan Desa Prabu Menang</td>
          </tr>
        </tbody>
      </Table>

	  <p className="text-start">
        Adapun letak dan peta Desa Pagardewa disajikan pada gambar berikut ini:
      </p>

      <div className="text-center">
        <img
          src="gbrareabiodaversity/gam7.jpg"
          alt="Peta Desa Bedegung"
          className="img-fluid border"
          style={{ maxWidth: "80%", height: "auto" }}
        />
        <div className="fst-italic text-muted mt-2">
          Peta Lokasi Stasiun Pagardewa
        </div>
		
      </div>
	  
    </Container>
	
	  
    </div>
  );
};

export default AreaBiodiversity;
